// extracted by mini-css-extract-plugin
export default {"mainContainer":"Sublime_mainContainer__DvMcc","contentArea":"Sublime_contentArea__8sVk-"};